import React from "react";
import { List, Switch } from "antd";
export const FieldSettings = () => {
  const getData = () => [
    {
      title: "Enable field Export",
      description: (
        <>Enable Exporting field reports to Excel,PDF,PowerPoint e.t.c</>
      ),
      actions: [
        <Switch
          checkedChildren="enable"
          unCheckedChildren="disable"
          defaultChecked
          disabled
        />,
      ],
    },

    {
      title: "Field column in Query",
      description: `Enable or disable field column option in querying and reporting`,
      actions: [
        <Switch
          checkedChildren="enable"
          unCheckedChildren="disable"
          defaultChecked
          onClick={() => {}}
          disabled
        />,
      ],
    },

    {
      title: "Field record management",
      description: `enable or disable CRUD operations on field tables`,
      actions: [
        <Switch
          checkedChildren="enable"
          unCheckedChildren="disable"
          defaultChecked
          disabled
        />,
      ],
    },
    
  ];
  return (
    <div
      className="ms-Grid"
      dir="ltr"
      style={{
        paddingTop: "8px",
        paddingRight: "40px",
        paddingBottom: "8px",
        paddingLeft: "40px",
      }}
    >
      <div className="ms-Grid-row">
        <div
          className="ms-Grid-col ms-sm12"
          style={{
            marginBottom: "12px",
            color: "rgba(0,0,0,.85)",
            fontWeight: "500",
            fontSize: "20px",
            lineHeight: "28px",
          }}
        >
          Field Reports Settings
        </div>
      </div>
      <div className="ms-Grid-row">
        <div className="ms-Grid-col ms-sm12">
          <List
            itemLayout="horizontal"
            dataSource={getData()}
            renderItem={(item) => (
              <List.Item actions={item.actions}>
                <List.Item.Meta
                  title={item.title}
                  description={item.description}
                />
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>
  );
};

